module.exports = __webpack_public_path__ + "img/sample-logo1.fcb07839.png";